var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.41881 14.4083V4.68646H0.190299V14.4083H3.41881ZM1.80523 3.35934C2.93084 3.35934 3.63161 2.61282 3.63161 1.67988C3.61054 0.725685 2.93084 0 1.82663 0C0.72167 0 0 0.725685 0 1.6798C0 2.61274 0.700516 3.35926 1.78407 3.35926L1.80523 3.35934ZM5.20583 14.4083H8.43409V8.97975C8.43409 8.68958 8.45516 8.39865 8.54045 8.19139C8.77373 7.61063 9.30493 7.00944 10.197 7.00944C11.3649 7.00944 11.8324 7.90088 11.8324 9.20792V14.4083H15.0606V8.83407C15.0606 5.84808 13.4681 4.45854 11.344 4.45854C9.6026 4.45854 8.83778 5.43273 8.41285 6.09624H8.43434V4.6868H5.206C5.24814 5.59882 5.20583 14.4083 5.20583 14.4083Z","fill":"white"}));
}

Linkedin.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
